import { event, payload } from '@conversa/reflex';

export const FetchProviderFeaturesRequested = event(
  '[ component | EditPatientDialogContainer ] Fetch Provider Features Requested',
  payload<{ providerCode: string }>(),
);
